import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import useFetch from "./useFetch";

export default function usePage() {
  const location = useLocation();
  const [page, setPage] = useState("home");
  const [runId, setRunId] = useState(null);

  const isCustomerListPage =
    location.pathname === "/" || /customer\/\d+/.test(location.pathname);

  const isSharePage = /viewer\//.test(location.pathname);

  const [projectId, setProjectId] = useState(null);

  const { data: simulationData } = useFetch(
    `${isSharePage ? "/hash" : ""}/simulation/${runId}`,
    {},
    !!runId
  );

  useEffect(() => {
    if (/project\/\d+/.test(location.pathname)) {
      const match = location.pathname.match(/\/project\/[a-z\d]+\/([^/]+)/);
      const type = match ? match[1] : null;
      if (type === "urban") {
        setPage("urban");
      } else if (type === "risk") {
        setPage("risk");
      } else {
        setPage("vegetation");
      }
    }

    // On simulation pages, the URL has no project segment — leave projectId
    // alone and let the simulationData effect below set it. Clobbering to
    // null here makes consumers (breadcrumb, runs list) flash on every click.
    const isSimulationPage = /\/simulation\/([^/]+)/.test(location.pathname);
    if (!isSimulationPage) {
      const match = location.pathname.match(/\/project\/([^/]+)/);
      const projectIdFromPath = match ? Number(match[1]) : null;

      const match1 = location.pathname.match(/^\/viewer\/project\/([^/]+)/);
      const hashIdFromPath = match1 ? match1[1] || "" : null;

      setProjectId(isSharePage ? hashIdFromPath : projectIdFromPath);
    }

    const match3 = location.pathname.match(/^\/viewer\/simulation\/([^/]+)/);
    const runHashIdFromPath = match3 ? match3[1] || "" : null;

    const match2 = location.pathname.match(/\/simulation\/([^/]+)/);
    const runIdFromPath = match2 ? Number(match2[1]) : null;
    setRunId(isSharePage ? runHashIdFromPath : runIdFromPath);
  }, [location.pathname, isSharePage]);

  useEffect(() => {
    if (simulationData) {
      if (simulationData.sim_type === "mtt") {
        setPage("vegetation");
      } else {
        setPage("urban");
      }
      setProjectId(
        isSharePage
          ? simulationData.xp_project_hash
          : simulationData.xp_project_id
      );
    }
  }, [simulationData, isSharePage]);

  return {
    page,
    isSharePage,
    isUrbanPage: page === "urban",
    isVegetationPage: page === "vegetation",
    isRiskPage: page === "risk",
    isCustomerListPage,
    projectId, // could be projectId or projectHash
    runId, // could be runId or runHash
    setRunId,
  };
}
